import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6ac5f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-wrap mt-3",
  style: {"gap":"5px"}
}
const _hoisted_2 = {
  key: 0,
  class: "w-100 d-flex justify-content-center"
}
const _hoisted_3 = {
  key: 1,
  class: "w-100 d-flex justify-content-center"
}
const _hoisted_4 = {
  key: 2,
  class: "w-100 d-flex justify-content-center"
}
const _hoisted_5 = { class: "text-muted ms-3" }
const _hoisted_6 = {
  key: 3,
  class: "w-100 d-flex justify-content-center"
}
const _hoisted_7 = { class: "text-muted ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_ProductListTile = _resolveComponent("ProductListTile")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (!_ctx.pageUI.isReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productCodesForGrid, (code, index) => {
              return (_openBlock(), _createBlock(_component_ProductListTile, {
                key: code,
                product: _ctx.getProduct(code),
                "is-drop-target": index === _ctx.dropTargetIndex,
                "is-draggable-and-deletable": true,
                pageUI: _ctx.pageUI,
                useProductCode: _ctx.useProductCodes,
                draggable: "true",
                onDragstart: ($event: any) => (_ctx.handleDragStart($event, index)),
                onDragover: _withModifiers(($event: any) => (_ctx.handleDragOver($event, index)), ["prevent"]),
                onDrop: ($event: any) => (_ctx.handleDrop($event, index)),
                onDragend: _ctx.handleDragEnd,
                onDeleteProduct: _ctx.deleteProduct
              }, null, 8, ["product", "is-drop-target", "pageUI", "useProductCode", "onDragstart", "onDragover", "onDrop", "onDragend", "onDeleteProduct"]))
            }), 128))
          ]),
          (_ctx.previewOnly && _ctx.codes.length > _ctx.initialNumberOfProducts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "btn text-reset text-decoration-underline text-uppercase fs-5",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMore && _ctx.showMore(...args)))
                }, " + " + _toDisplayString(_ctx.$t('showMoreProducts')), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.previewOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "btn text-reset text-decoration-underline text-uppercase fs-5",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showLess && _ctx.showLess(...args)))
                }, " - " + _toDisplayString(_ctx.$t('showLessProducts')), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.previewOnly && _ctx.codes.length > _ctx.maxNumberOfProducts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('moreResultsInOtherView')), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.codes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('noProducts')), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}